import CommonUtil from './commonUtil';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { MAX_AGE_DEVICE_ID } from '../utils/clientConstant'

export class Client {
  clientjs;
  constructor() {
    if (Client.instance) {
      Client.instance = this;
    }
    return Client.instance;
  }

  getClientJs = async () => {
    if (!this.clientjs) {
      const { ClientJS } = await import('clientjs');
      this.clientjs = new ClientJS();
    }
    return this.clientjs;
  };

  getFingerPrintKey = async () => {
    const clientjs = await this.getClientJs();
    let isMobileJS = clientjs.isMobile();
    let screen_print = '';
    if (isMobileJS) {
      screen_print = clientjs.getScreenPrint();
    }

    let device =
      clientjs.getBrowser() +
      clientjs.getEngine() +
      clientjs.getDeviceVendor() +
      clientjs.getCPU() +
      isMobileJS +
      clientjs.isIpad() +
      screen_print +
      clientjs.getLanguage() +
      clientjs.getCanvasPrint();

    if (process.env.FINGERPRINT_OLD === 'true') {
      device =
        clientjs.getBrowserData().ua +
        clientjs.getOS() +
        clientjs.getCPU() +
        clientjs.getSystemLanguage();
    }
    return device;
  };
  setFp = async () => {
    const fp = await FingerprintJS.load();
    const { visitorId } = await fp.get();
    return visitorId;
  };
  getFingerPrint = async () => {
    const clientjs = await this.getClientJs();
    return clientjs.getCustomFingerprint(await this.setFp(), null);
  };

  getDeviceId = async () => {
    try {
      const device_id = `${CommonUtil.getBrowserIdForRuc()}-${await this.getFingerPrint()}`;
      return device_id;
    } catch (error) {
      console.error('Error generate device');
      return '';
    }
  };

  clientIsMobile = async () => (await this.getClientJs()).isMobile();
}

let client;
const getClient = () => {
  if (!client) {
    client = new Client();
  }
  return client;
};

export const getClientDeviceId = async (device_id = '') => {
  if (device_id) {
    return device_id;
  }
  const deviceIdFromCookie = CommonUtil.readCookie('deviceId');
  if (deviceIdFromCookie) {
    console.log(
      'GENERATE_DEVICE_ID_LOG',
      'Get deviceId from cookie',
      deviceIdFromCookie,
    );
    return deviceIdFromCookie;
  }
  const deviceId = await getClient().getDeviceId();
  const subDomainName = CommonUtil.createSubDomainName(window.location.host);
  console.log('GENERATE_DEVICE_ID_LOG', 'Set deviceId cookie', deviceId);
  CommonUtil.createCookiewithSubDomain(
    'deviceId',
    deviceId,
    '/',
    subDomainName,
    `max-age=${MAX_AGE_DEVICE_ID}`,
  );
  return deviceId;
};

export default getClient;
